import { Link } from "react-router-dom";
import StatusBadge from "@/components/StatusBadge";
import TestResultBadge from "@/components/TestResultBadge";
import { FileText, Pencil, Trash2, RotateCcw, Lock, Unlock, Copy } from "lucide-react";

export const TestRow = ({ test: t, canWrite, canDelete, canUnlock, onRowOpen, onDelete, onRestore, onUnlock }) => (
  <tr
    data-testid={`test-row-${t.id}`}
    onDoubleClick={() => onRowOpen(t)}
    title={t.blown_out_employee_id ? "Double-click to open certificate (record locked)" : "Double-click to edit"}
    className={`border-t border-[#33424f]/10 hover:bg-[#f5f1ec] cursor-pointer select-none ${t.deleted_at ? "opacity-50 line-through" : ""}`}
  >
    <td className="px-4 py-3 whitespace-nowrap">
      <StatusBadge status={t.status} size="sm" />
    </td>
    <td className="px-4 py-3 subtitle text-[#33424f] whitespace-nowrap overflow-hidden text-ellipsis">{t.job_number}</td>
    <td className="px-4 py-3 font-body whitespace-nowrap overflow-hidden text-ellipsis">{t.vessel_type}</td>
    <td className="px-4 py-3 font-body text-[#50493b] whitespace-nowrap overflow-hidden text-ellipsis">{t.vessel_number || "—"}</td>
    <td className="px-4 py-3 font-body whitespace-nowrap">
      <TestResultBadge value={t.test_result} />
    </td>
    <td className="px-4 py-3 font-body whitespace-nowrap overflow-hidden text-ellipsis">{t.test_pressure || "—"}</td>
    <td className="px-4 py-3 font-body whitespace-nowrap overflow-hidden text-ellipsis">{t.test_medium || "—"}</td>
    <td className="px-4 py-3 font-body text-[#50493b] whitespace-nowrap overflow-hidden text-ellipsis">{t.test_date || "—"}</td>
    <td className="px-4 py-3 text-right whitespace-nowrap" onDoubleClick={(e) => e.stopPropagation()}>
      <div className="inline-flex items-center gap-1">
        <Link
          data-testid={`certificate-link-${t.id}`}
          to={`/tests/${t.id}/certificate`}
          onClick={(e) => e.stopPropagation()}
          className="p-1.5 hover:bg-[#e6e0db] text-[#33424f]"
          title="Certificate"
        >
          <FileText className="w-4 h-4" />
        </Link>
        {canWrite && t.deleted_at ? null : canWrite && t.blown_out_employee_id ? (
          <>
            <span
              data-testid={`lock-indicator-${t.id}`}
              className="p-1.5 text-[#33424f]"
              title={`Locked — Complete ${t.blown_out_date || ""}`}
            >
              <Lock className="w-4 h-4" />
            </span>
            {canUnlock && (
              <button
                data-testid={`unlock-test-${t.id}`}
                onClick={(e) => { e.stopPropagation(); onUnlock(t.id); }}
                className="p-1.5 hover:bg-[#f5ead0] text-[#8a6d00]"
                title="Unlock record (admin) — makes it editable & deletable"
              >
                <Unlock className="w-4 h-4" />
              </button>
            )}
            <Link
              data-testid={`retest-link-${t.id}`}
              to={`/tests/new?clone_from=${t.id}`}
              onClick={(e) => e.stopPropagation()}
              className="p-1.5 hover:bg-[#e6f3ff] text-[#39678f]"
              title="Log a re-test (after repair/replacement)"
            >
              <Copy className="w-4 h-4" />
            </Link>
          </>
        ) : (
          canWrite && (
            <Link
              data-testid={`edit-test-${t.id}`}
              to={`/tests/${t.id}`}
              onClick={(e) => e.stopPropagation()}
              className="p-1.5 hover:bg-[#e6e0db] text-[#33424f]"
              title="Edit"
            >
              <Pencil className="w-4 h-4" />
            </Link>
          )
        )}
        {canDelete && !t.deleted_at && !t.blown_out_employee_id && (
          <button
            data-testid={`delete-test-${t.id}`}
            onClick={(e) => { e.stopPropagation(); onDelete(t.id); }}
            className="p-1.5 hover:bg-[#fbe4ea] text-[#b30035]"
            title="Soft-delete"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        )}
        {canDelete && t.deleted_at && (
          <button
            data-testid={`restore-test-${t.id}`}
            onClick={(e) => { e.stopPropagation(); onRestore(t.id); }}
            className="p-1.5 hover:bg-[#e8f6e2] text-[#2d5e1f]"
            title="Restore"
          >
            <RotateCcw className="w-4 h-4" />
          </button>
        )}
      </div>
    </td>
  </tr>
);
